import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaPlay } from "react-icons/fa";
import { FiUpload } from "react-icons/fi";
import "./HeroSection.css";
import AddPrescriptionForm from "../../Prescription/AddPrescriptionForm";
import logo from '../../../Assets/Banner/herosectionimg.png'

const HeroSection = () => {
  const [slider, setSlider] = useState(null);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://api.swasthmitra.com/api/mainslider/get")
      .then((res) => {
        if (res.data?.sliders?.length) setSlider(res.data.sliders[0]);
      })
      .catch((err) => console.error("Error fetching sliders:", err));
  }, []);

  // const title = slider?.description || "अब दवा के लिए कहीं जाने की ज़रूरत नहीं";
  // const subtitle = slider?.name || "डॉक्टर की लिखी दवा अब सीधे आपके घर तक";
  const title = "अब दवा के लिए कहीं जाने की ज़रूरत नहीं";
  const subtitle = "डॉक्टर की लिखी दवा अब सीधे आपके घर तक";
  const image = logo;

  // Split title: first line green, second line dark
  const words = title.split(" ");
  const mid = Math.ceil(words.length / 2);
  const line1 = words.slice(0, mid).join(" ");
  const line2 = words.slice(mid).join(" ");

  return (
    <section className="hero-section">
      <div className="hero-inner">
        <div className="hero-text">
          <h1>
            <span className="hero-title-green title-gradient">{line1}</span>
            <br />
            <span className="hero-title-dark">{line2}</span>
          </h1>
          <p className="hero-sub">{subtitle}</p>

          <div className="hero-actions">
            <button className="hero-cta"  onClick={() => setIsFormOpen(true)}>
              <span className="hero-cta-icon"><FaPlay /></span>
              <span>अभी दवा मंगाएँ</span>
            </button>
            <button className="hero-upload" onClick={() => setIsFormOpen(true)}>
              <FiUpload size={18} />
              <span>या पर्चा अपलोड करें</span>
            </button>
          </div>
        </div>

        <div className="hero-image">
          <img src={image} alt={subtitle} />
        </div>
      </div>

      {isFormOpen && <AddPrescriptionForm onClose={() => setIsFormOpen(false)} />}
    </section>
  );
};

export default HeroSection;
